//加载当前帐套信息
import {QueryCommand} from "xmgoing-server";
import {StorageUtils} from 'xmgoing-utils';
import {getFileList} from "@/components/fileCtl/api/file";
import SysConfigUtils from "@/utils/sysConfigUtils";


export function setIconUrl(iconUrl) {
  const iconLink: any = document.querySelector("link[rel*='icon']");
  iconLink && iconLink.setAttribute("href", iconUrl);
}
/**
 * 获取界面的icon 根据busId
 * @param websiteDomainIcon
 */
export async function initPageIconByBusId(websiteDomainIcon) {
  const websiteDomainIconUrl = StorageUtils.getSessionItem('websiteDomainIconUrl');
  if (websiteDomainIconUrl) {
    setIconUrl(websiteDomainIconUrl);
  } else {
    const list = await getFileList(websiteDomainIcon);
    if (list && list.records && list.records[0]) {
      StorageUtils.addSessionItem('websiteDomainIconUrl', `${SysConfigUtils.go_eplat_adress}/api/pe-attachment/attachment/showImg/${list.records[0].id}`);
      setIconUrl(`${SysConfigUtils.go_eplat_adress}/api/pe-attachment/attachment/showImg/${list.records[0].id}`);
    }
  }
}

/**
 * 根据领域配置来初始化icon
 * @param websiteDomain
 * @param websiteDomainIcon
 * @param notFun
 */
export const initDomainIcon = function ({websiteDomain, websiteDomainIcon}: any, notFun?: any) {
  const hrefStr = window.location.href;
  if ((hrefStr+'').indexOf(websiteDomain)>= 0) {
    initPageIconByBusId(websiteDomainIcon);
  } else {
    notFun && notFun();
  }
}

/**
 *  根据busId初始化界面logo
 * @param websiteDomainIcon
 */
export async function initPageLogoByBusId({websiteDomain, websiteDomainLogo}, backFun) {
  const hrefStr = window.location.href;
  if ((hrefStr+'').indexOf(websiteDomain)>= 0) {
    const websiteDomainLogoUrl = StorageUtils.getSessionItem('websiteDomainLogo');
    if(websiteDomainLogoUrl){
      backFun && backFun(websiteDomainLogoUrl);
      return
    }
    const list = await getFileList(websiteDomainLogo);
    if (list && list.records && list.records[0]) {
      StorageUtils.addSessionItem('websiteDomainLogo',`${SysConfigUtils.go_eplat_adress}/api/pe-attachment/attachment/showImg/${list.records[0].id}`);
      backFun && backFun(`${SysConfigUtils.go_eplat_adress}/api/pe-attachment/attachment/showImg/${list.records[0].id}`);
    }else{
      backFun && backFun();
    }
  }else{
    backFun && backFun();
  }
}


/**
 * 初始化系统的icon
 * @param systemIco
 */
const initSystemIcon = function (systemIco) {
  if (systemIco && systemIco.length > 0) {
    setIconUrl(systemIco);
  }
}

/**
 * 初始化界面的icon定义信息
 * @param sysConfigJson
 */
function initPageIco(sysConfigJson) {
  const {websiteDomain, websiteDomainIcon, systemIco} = sysConfigJson;
  if (websiteDomain) {
    initDomainIcon({websiteDomain, websiteDomainIcon},()=>{
      initSystemIcon(systemIco);
    });
  } else {
    initSystemIcon(systemIco);
  }
}

/**
 * 初始化系统标题
 * @param systemTitle
 * @param systemTitleEn
 */
export function initPageTitle({systemTitle, systemTitleEn}) {
  if (systemTitle && systemTitle.length > 0) {
    const projectI18n = StorageUtils.getSessionItem("projectI18n") === "en-US" ? "en-US" : "zh-CN";
    if (projectI18n === 'en-US') {
      if((systemTitleEn+'').trim()){
        document.title = systemTitleEn;
      }
      window.localStorage.setItem("documentTitle", systemTitleEn);
    } else {
      if((systemTitle+'').trim()){
        document.title = systemTitle;
      }
      window.localStorage.setItem("documentTitle", systemTitle);
    }
  }
}


/**
 * 加载系统配置信息
 * @param account
 * @returns {Promise<AxiosResponse<any>>}
 */
export const loadCurSystemConfig = async (backFun?: any) => {
  const data = StorageUtils.getItem("loadCurSystemConfig");
  if (data) {
    try {
      const sysConfigJson = JSON.parse(data);
      initPageIco(sysConfigJson);
      initPageTitle(sysConfigJson);
      return backFun && backFun(sysConfigJson);
    } catch (e) {
      StorageUtils.removeItem("loadCurSystemConfig");
      loadCurSystemConfig(backFun);
    }
  } else {
    const queryCommand = new QueryCommand({
      url: `/api/pe-portal/appStartConfig/getAppStartConfig`,
      method: "GET",
      showTip: false,
    });
    //执行查询操作
    let successFun = (sysConfigJson: any) => {
      StorageUtils.addItem("loadCurSystemConfig", JSON.stringify(sysConfigJson));
      initPageIco(sysConfigJson);
      initPageTitle(sysConfigJson);
      backFun && backFun(sysConfigJson);
    };
    queryCommand.executeQuery({successFun});
  }
};
